
const endpoints = {

    getAllFaqs: "faqs/",
    stayConnected: "stayconnected/",
    contactUs: "contact/",
    testimonials: "testimonials/",
    aboutUs: "aboutus/",
    platforms: "platforms/",
    blog: "blogs/",
    blogDetails:"blogs",
    termsCondition: "termsandconditions/",
    privacyPolicy: "privacypolicy/",
    recentBlogs:"related-posts/",
    leadership:"leadership/",
    stayconnected:"stayconnected/",
    video:"video/",
    info:"info/",
    download:"downloadpdf/"




}

export default endpoints;